import { styled, Typography } from "@mui/material";
import { PaddedPaper } from "components/surfaces/PaddedPaper";
import { useTranslation } from "react-i18next";
import { BackgroundLayerSelect } from "./BackgroundLayerSelect";
import { SelectBorderLayer } from "./OverlayerSelect";
import { PersonalLayers } from "../PersonalLayers";

export function SelectBaseLayerWrapper() {
  const { t } = useTranslation();
  return (
    <StyledPaper>
      <Typography variant="h3">{t("label.backgroundLayers")}</Typography>
      <BackgroundLayerSelect />
      <Typography variant="h3">{t("label.borders")}</Typography>
      <SelectBorderLayer />
      <Typography variant="h3">{t("label.myLayers")}</Typography>
      <PersonalLayers />
    </StyledPaper>
  );
}

const StyledPaper = styled(PaddedPaper)`
  margin-right: ${({ theme }) => theme.spacing(2)};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  max-width: ${({ theme }) => theme.spacing(40)};
  max-height: 80vh;
  overflow-y: auto;
`;
